import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Popover,
  PopoverHeader,
  PopoverBody,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import arrayMove from "array-move";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { updateFormList, updateFomeName, formEdited } from "FormBuilderAction";
import FormItem from "./form-item";
import Contries from "CountryList";
import LocaleStrings from "Languages";

// react-sortablle-hoc start
const SortableItem = SortableElement(({ value, index, source }) => (
  <FormItem key={index} list={value} source={source} />
));

const SortableList = SortableContainer(({ items, source }) => {
  return (
    <ul style={{ paddingLeft: 0 }}>
      {items.map((value, index) => {
        return (
          <SortableItem
            key={`item-${index}`}
            index={index}
            value={value}
            source={source}
          />
        );
      })}
    </ul>
  );
});
//react-sortablle-hoc end

class FormBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formName: props.formName,
    };
    this.listRef = React.createRef();
    this.draggedId = "";
  }

  componentDidMount() {
    // this.props.updateFomeName('Form Name');
  }

  handleClick = () =>
    this.listRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

  dragNewElement = (e) => {
    var { CountryList } = this.props;

    // this.props.updateFomeName('New Form Name')

    var newKey = e.currentTarget.attributes["data-key"].value;
    var newText = e.currentTarget.attributes["data-text"].value;
    var header = e.currentTarget.attributes["header-text"].value;
    var newName = e.currentTarget.attributes["data-name"].value;
    var isDefaultField =
      e.currentTarget.attributes["data-default"].value == "true" ? true : false;
    var taborder = this.props.oldKeys.length + 1;
    // var isActive = true;
    var isActive =
      e.currentTarget.attributes["data-public"].value == "false" ? false : true;

    var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var random1 = [...Array(10)].reduce(
      (a) => a + p[~~(Math.random() * p.length)],
      ""
    );
    var random2 = [...Array(5)].reduce(
      (a) => a + p[~~(Math.random() * p.length)],
      ""
    );
    var random3 = [...Array(5)].reduce(
      (a) => a + p[~~(Math.random() * p.length)],
      ""
    );
    var random4 = [...Array(10)].reduce(
      (a) => a + p[~~(Math.random() * p.length)],
      ""
    );
    var random5 = Date.now();

    var random = isDefaultField
      ? newName
      : random1 + "-" + random2 + "-" + random3 + "-" + random4 + "-" + random5;
    var fieldName = isDefaultField ? newName : newName + random1 + random5;
    var defaultOptions = isDefaultField
      ? [
          { value: "software", text: "Software", displayfields: "" },
          { value: "automation", text: "Automation", displayfields: "" },
          { value: "gaming", text: "Gaming", displayfields: "" },
          { value: "it", text: "IT", displayfields: "" },
        ]
      : [
          { value: "option_1", text: "option 1", displayfields: "" },
          { value: "option_2", text: "option 2", displayfields: "" },
          { value: "option_3", text: "option 3", displayfields: "" },
        ];

    if (newKey === "dropdown" && newName === "country") {
      var countrylist = [];
      if (CountryList && CountryList.response) {
        CountryList.response.map((item) => {
          var obj = {
            value: item.country,
            text: item.country,
            displayfields: "",
          };
          countrylist.push(obj);
        });
      }
      defaultOptions = countrylist.length > 0 ? countrylist : Contries;
    }

    var newObj = {};
    if (
      newKey === "textinput" ||
      newKey === "numberinput" ||
      newKey === "textarea"
    ) {
      newObj = {
        key: newKey,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        maxlen: "250",
        label: newText,
        name: fieldName,
        id: random,
        header: header,
        taborder: taborder,
      };
    } else if (
      newKey === "checkboxes" ||
      newKey === "radiobuttons" ||
      newKey === "dropdown"
    ) {
      newObj = {
        key: newKey,
        hasCondition: false,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        name: fieldName,
        id: random,
        header: header,
        taborder: taborder,
        options: defaultOptions,
      };
    } else if (newKey === "singlecheckbox") {
      newObj = {
        key: newKey,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        name: fieldName,
        id: random,
        header: header,
        taborder: taborder,
      };
    } else if (newKey === "image") {
      newObj = {
        key: newKey,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        name: fieldName,
        id: random,
        label: newText,
        width: "100",
        height: "100",
        header: header,
        taborder: taborder,
      };
    } else if (newKey === "hyperlink") {
      newObj = {
        key: newKey,
        name: fieldName,
        id: random,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        link: "https://eventify.io/",
        header: header,
        taborder: taborder,
      };
    } else if (newKey === "datepicker") {
      newObj = {
        key: newKey,
        name: fieldName,
        id: random,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        header: header,
        taborder: taborder,
      };
    } else if (newKey === "rating") {
      newObj = {
        key: newKey,
        name: fieldName,
        id: random,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        header: header,
        taborder: taborder,
      };
    } else if (newKey === "label" || newKey === "paragraph") {
      newObj = {
        key: newKey,
        name: fieldName,
        id: random,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        header: header,
        taborder: taborder,
      };
    } else if (newKey === "file") {
      var maxUpload = e.currentTarget.attributes["data-upload"].value;
      var ftype = e.currentTarget.attributes["data-type"].value;

      newObj = {
        key: newKey,
        name: fieldName,
        id: random,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        label: newText,
        header: header,
        taborder: taborder,
        maxupload: maxUpload,
        filetype: ftype,
        maxuploadsize: "100",
      };
    } else if (newKey === "group") {
      var gtype = e.currentTarget.attributes["data-type"].value;
      var entries = e.currentTarget.attributes["data-entries"].value;

      var defaultOptions = [];
      if (gtype === "products") {
        defaultOptions = [
          {
            key: "file",
            filetype: "image",
            required: true,
            maxupload: 2,
            label: "Images",
            name: "productimages",
            id: "productimages",
          },
          {
            key: "dropdown",
            required: true,
            label: "Category",
            name: "productcategory",
            id: "productcategory",
            options: [],
          },
          {
            key: "dropdown",
            required: true,
            label: "Sub-Category",
            name: "productsubcategory",
            id: "productsubcategory",
            options: [],
          },
          {
            key: "textinput",
            required: true,
            maxlen: 250,
            label: "Title",
            name: "producttitle",
            id: "producttitle",
          },
          {
            key: "textarea",
            required: true,
            maxlen: 1000,
            label: "About",
            name: "productinfo",
            id: "productinfo",
          },
        ];
      } else if (gtype === "coupons") {
        defaultOptions = [
          {
            key: "textinput",
            required: true,
            maxlen: 250,
            label: "Title",
            name: "coupontitle",
            id: "coupontitle",
          },
          {
            key: "textarea",
            required: true,
            maxlen: 1000,
            label: "About",
            name: "couponabout",
            id: "couponabout",
          },
          {
            key: "textinput",
            required: true,
            maxlen: 250,
            label: "Coupon Code",
            name: "couponecode",
            id: "couponecode",
          },
          {
            key: "datepicker",
            required: true,
            label: "Valid Till",
            name: "couponvalidtill",
            id: "couponvalidtill",
          },
        ];
      } else if (gtype === "deals") {
        defaultOptions = [
          {
            key: "textinput",
            required: true,
            maxlen: 250,
            label: "Title",
            name: "dealtitle",
            id: "dealtitle",
          },
          {
            key: "textarea",
            required: true,
            maxlen: 1000,
            label: "About",
            name: "dealabout",
            id: "dealabout",
          },
          {
            key: "datepicker",
            required: true,
            label: "Valid Till",
            name: "dealvalidtill",
            id: "dealvalidtill",
          },
        ];
      } else if (gtype === "abstract") {
        defaultOptions = [
          {
            key: "label",
            required: true,
            maxlen: 250,
            label: "Enter your title",
            name: "faqtitle",
            id: "faqtitle",
          },
          {
            key: "paragraph",
            required: true,
            maxlen: 1000,
            label: "Enter your description",
            name: "faqdesc",
            id: "faqdesc",
          },
        ];
      }

      newObj = {
        key: newKey,
        type: gtype,
        name: fieldName,
        id: random,
        defaultfields: isDefaultField,
        isactive: isActive,
        required: false,
        maxentries: entries,
        label: newText,
        header: header,
        taborder: taborder,
        groupfields: defaultOptions,
      };
    }

    this.draggedId = random;
    this.props.updateFormList(newObj, this.props.oldKeys, "add");
    this.handleClick();

    this.props.formEdited(true); // This is used for edit form
  };

  renderForm = () => {
    if (this.props.oldKeys && this.props.oldKeys.length > 0) {
      return _.map(this.props.oldKeys, (list, index) => {
        return <FormItem key={index} list={list} draggedId={this.draggedId} />;
      });
    }
  };

  renderFixedForm = () => {
    let { formBuilderData } = this.props;
    if (formBuilderData && formBuilderData.fixedFields) {
      return _.map(formBuilderData.fixedFields, (list, index) => {
        return <FormItem key={index} list={list} />;
      });
    }
  };

  /**
   * Sort form list
   */
  onSortEnd = ({ oldIndex, newIndex }) => {
    // var arrAvailable = this.props.availableFeatures;
    var arrAvailable = this.props.oldKeys;

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

    var newArrAvailable = [];

    //Just map the array and reset the taborder as now taborder is same as the object position
    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, taborder: index + 1 });
    });
    this.props.updateFormList(newArrAvailable, this.props.oldKeys, "samearray");
    this.props.formEdited(true); // This is used for edit form
  };

  formNameChange = (e) => {
    var value = e.target.value;
    this.setState({ formName: value });
  };

  updateFromName = () => {
    this.props.updateFomeName(this.state.formName);
    this.props.formEdited(true); // This is used for edit form
    document.body.click(); // Close the popover after save
  };

  /**
   * =============================================================================================
   */
  render() {
    var { formName, oldKeys, source, version, formBuilderData } = this.props;

    var hrstyle = {
      margin: "0px 10px 15px 10px",
      borderTop: "2px solid #e6edf3",
    };

    var biagrophy = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "biography";
    });
    var company = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "company";
    });
    var designation = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "designation";
    });
    // var interest = _.filter(oldKeys, (obj) => {return obj.name.toLowerCase() == 'interest'});
    var videourl = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "videourl";
    });
    var sponsor_spoc = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "sponsor_spoc";
    });
    var sponsoremail = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "sponsoremail";
    });
    var phonenumber = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "phonenumber";
    });
    var website = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "weblink";
    });
    var facebook = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "facebook";
    });
    var twitter = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "twitter";
    });
    var linkedin = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "linkedin";
    });
    var instagram = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "instagram";
    });
    var whatsapp = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "whatsapp";
    });
    var gdpr = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "isnetworking";
    });
    var terms = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "termsconditions";
    });
    var industry = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "industry";
    });
    var products = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "products";
    });
    var galleryimages = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "galleryimages";
    });
    var galleryvideos = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "galleryvideos";
    });
    var documents = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "documents";
    });
    var coupons = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "coupons";
    });
    var deals = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "deals";
    });
    var email = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "email";
    });
    var contactperson = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "contactperson";
    });
    var address = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "address";
    });
    var country = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "country";
    });
    var sessioncomment = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "comment";
    });
    var sessiongr = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "general";
    });
    var sessionsr = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "speaking";
    });
    var sessionpr = _.filter(oldKeys, (obj) => {
      return obj.name.toLowerCase() == "presentation";
    });

    var disableField = { cursor: "default", backgroundColor: "#DEE2E9" };
    console.log("formBuilderData :- ", formBuilderData);
    return (
      <div
        className="react-form-builder clearfix h-full"
        style={{ backgroundColor: "#f9fafc" }}
      >
        <div className="proposal-note-fortab">
          Note: Drag and drop toolbox does not work for Ipad and Tab
        </div>
        <div className="checkout-form-builder-container h-full overflow-hidden">
          <div className="scrollable-modal react-form-builder-preview pull-left- widthfortab">
            <span className="form-name">{formName.toString()}</span>

            <OverlayTrigger
              trigger="click"
              placement="left"
              rootClose
              overlay={
                <Popover
                  title="Form Name"
                  id="popover-basic"
                  // style={{ padding: "10px" }}
                >
                  <PopoverHeader>
                    <h3 className="popover-title">Form Name</h3>
                  </PopoverHeader>
                  <PopoverBody>
                    <div className="form-group">
                      <label
                        className="label-text"
                        style={{ textAlign: "left" }}
                      >
                        {" "}
                        Form Name{" "}
                      </label>
                      <div>
                        <input
                          className="form-control"
                          type="text"
                          name="name"
                          id="name"
                          onChange={this.formNameChange}
                          defaultValue={formName}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className=" ">
                      <button
                        id="save"
                        className="btn btn-primary "
                        onClick={this.updateFromName}
                      >
                        {LocaleStrings.button_save}
                      </button>
                      &nbsp;
                      <button
                        id="cancel"
                        className="btn btn-default"
                        onClick={() => document.body.click()}
                      >
                        {LocaleStrings.button_cancel}
                      </button>
                    </div>
                  </PopoverBody>
                </Popover>
              }
            >
              <i
                className="is-isolated fa fa-pencil-square-o"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
            <div className="form-subheading" style={{ marginBottom: "20px" }}>
              {LocaleStrings.dynamic_form_subtext_create_update_form}
            </div>
            {/* Verion Commented by Udayan on 28/02/22 as per new */}
            {/* {
                // This is used for edit form
                this.props.version ? (
                  <div
                    className="pull-right"
                    style={{ fontSize: 20, marginRight: 20 }}
                  >
                    <span> {LocaleStrings.version} : </span>{" "}
                    {this.props.version}
                  </div>
                ) : (
                  ""
                )
              } */}
            {/* <hr /> */}
            <div className="edit-form"></div>
            <div className="Sortable" style={{ cursor: "default" }}>
              {this.renderFixedForm()}
            </div>
            {this.props.oldKeys && this.props.oldKeys.length > 0 ? (
              <>
                <div className="Sortable">
                  <SortableList
                    items={this.props.oldKeys}
                    onSortEnd={this.onSortEnd}
                    pressDelay={200}
                    lockAxis="y"
                    source={source}
                  />

                  <div ref={this.listRef}></div>
                </div>

                {formBuilderData.key === "add" ? (
                  <>
                    {formBuilderData.category === "checkout" ? (
                      <div className="" style={{ padding: "24px" }}>
                        <b className="form-name">{LocaleStrings.note} </b>{" "}
                        <p className="form-subheading">
                          - {LocaleStrings.dynamic_form_note2}
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <div className="" style={{ padding: "24px" }}>
                    <b className="form-name">{LocaleStrings.note} </b>{" "}
                    {formBuilderData.category === "checkout" ? (
                      <p>- {LocaleStrings.dynamic_form_note2}</p>
                    ) : (
                      ""
                    )}
                    <p className="form-subheading">
                      - {LocaleStrings.dynamic_form_note1}
                    </p>
                  </div>
                )}
              </>
            ) : (
              <div>
                <div draggable="true">
                  <div className="form-place-holder">
                    <div>
                      {LocaleStrings.dynamic_form_text_drop_a_item_here}....
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Right side boxes lists */}
          <div className="scrollable-modal react-form-builder-toolbar pull-right- paddingleft-fortab">
            <h4>{LocaleStrings.dynamic_form_text_toolbox}</h4>
            <hr style={hrstyle} />
            {source !== "survey" && source !== "quiz" ? (
              source === "checkout" ? (
                <p className="vertical-align-center subheading-formcomponent">
                  {LocaleStrings.dynamic_form_text_contact_fields}{" "}
                  <OverlayTrigger
                    key="contact-fields"
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-contact-fields">
                        {LocaleStrings.dynamic_form_text_contact_fields_info}
                      </Tooltip>
                    }
                  >
                    <i className="fa fa-info-circle pointer ml-10"></i>
                  </OverlayTrigger>
                </p>
              ) : source === "sessionrating" ? (
                <>
                  {/* <p className="subheading-formcomponent">
                      {LocaleStrings.dynamic_form_text_default_fields}
                    </p> */}
                </>
              ) : (
                <p className="subheading-formcomponent">
                  {LocaleStrings.dynamic_form_text_contact_fields}
                </p>
              )
            ) : (
              ""
            )}

            {source === "exhibitor" ? (
              <ul>
                <li
                  className="d-flex content-centertab"
                  data-key="dropdown"
                  header-text="Dropdown"
                  data-default="true"
                  data-public="true"
                  data-name="industry"
                  data-text="Industry"
                  draggable={industry && industry.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={industry && industry.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-industry"></i>
                  <p className="toolboxname">Industry</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="group"
                  data-type="products"
                  data-entries="10"
                  header-text="Group Data"
                  data-default="true"
                  data-public="true"
                  data-name="products"
                  data-text="Products"
                  draggable={products && products.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={products && products.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-product-hunt"></i>
                  <p className="toolboxname">Products</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="image"
                  data-upload="10"
                  header-text="File"
                  data-default="true"
                  data-public="true"
                  data-name="galleryimages"
                  data-text="Gallery Images"
                  draggable={
                    galleryimages && galleryimages.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    galleryimages && galleryimages.length > 0
                      ? disableField
                      : {}
                  }
                >
                  <i className="fa fa-upload"></i>
                  <p className="toolboxname">Gallery Images</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="video"
                  data-upload="10"
                  header-text="File"
                  data-default="true"
                  data-public="true"
                  data-name="galleryvideos"
                  data-text="Gallery Videos"
                  draggable={
                    galleryvideos && galleryvideos.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    galleryvideos && galleryvideos.length > 0
                      ? disableField
                      : {}
                  }
                >
                  <i className="fa fa-upload"></i>
                  <p className="toolboxname">Gallery Videos</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="document"
                  data-upload="5"
                  header-text="File"
                  data-default="true"
                  data-public="true"
                  data-name="documents"
                  data-text="Other Documents"
                  draggable={documents && documents.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={documents && documents.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-upload"></i>
                  <p className="toolboxname">Other Documents</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="group"
                  data-type="coupons"
                  data-entries="2"
                  header-text="Group Data"
                  data-default="true"
                  data-public="true"
                  data-name="coupons"
                  data-text="Coupons"
                  draggable={coupons && coupons.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={coupons && coupons.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-ticket"></i>
                  <p className="toolboxname">Coupons</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="group"
                  data-type="deals"
                  data-entries="2"
                  header-text="Group Data"
                  data-default="true"
                  data-public="true"
                  data-name="deals"
                  data-text="Deals"
                  draggable={deals && deals.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={deals && deals.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-shield"></i>
                  <p className="toolboxname">Deals</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="email"
                  data-text="Email"
                  draggable={email && email.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={email && email.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-envelope-o"></i>
                  <p className="toolboxname">Email</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="false"
                  data-name="phonenumber"
                  data-text="Phone Number"
                  draggable={
                    phonenumber && phonenumber.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    phonenumber && phonenumber.length > 0 ? disableField : {}
                  }
                >
                  <i className="fa fa-phone"></i>
                  <p className="toolboxname">Phone Number</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="contactperson"
                  data-text="Contact Person"
                  draggable={
                    contactperson && contactperson.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    contactperson && contactperson.length > 0
                      ? disableField
                      : {}
                  }
                >
                  <i className="fa fa-user"></i>
                  <p className="toolboxname">Contact Person</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textarea"
                  header-text="Textarea"
                  data-default="true"
                  data-public="true"
                  data-name="address"
                  data-text="Address"
                  draggable={address && address.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={address && address.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-map-marker"></i>
                  <p className="toolboxname">Address</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="dropdown"
                  header-text="Country"
                  data-default="true"
                  data-public="true"
                  data-name="country"
                  data-text="country"
                  draggable={country && country.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={country && country.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-globe"></i>
                  <p className="toolboxname">Country</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="weblink"
                  data-text="Website"
                  draggable={website && website.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={website && website.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-globe"></i>
                  <p className="toolboxname">Website</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="facebook"
                  data-text="Facebook"
                  draggable={facebook && facebook.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={facebook && facebook.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-facebook"></i>
                  <p className="toolboxname">Facebook</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="twitter"
                  data-text="Twitter"
                  draggable={twitter && twitter.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={twitter && twitter.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-twitter"></i>
                  <p className="toolboxname">Twitter</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="linkedin"
                  data-text="Linkedin"
                  draggable={linkedin && linkedin.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={linkedin && linkedin.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-linkedin"></i>
                  <p className="toolboxname">Linkedin</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="instagram"
                  data-text="Instagram"
                  draggable={instagram && instagram.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={instagram && instagram.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-instagram"></i>
                  <p className="toolboxname">Instagram</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="whatsapp"
                  data-text="Whatsapp"
                  draggable={whatsapp && whatsapp.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={whatsapp && whatsapp.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-whatsapp"></i>
                  <p className="toolboxname">Whatsapp</p>
                </li>
              </ul>
            ) : source === "sponsor" ? (
              <ul>
                <li
                  className="d-flex content-centertab"
                  data-key="dropdown"
                  header-text="Dropdown"
                  data-default="true"
                  data-public="true"
                  data-name="industry"
                  data-text="Industry"
                  draggable={industry && industry.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={industry && industry.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-industry"></i>
                  <p className="toolboxname">Industry</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="image"
                  data-upload="10"
                  header-text="File"
                  data-default="true"
                  data-public="true"
                  data-name="galleryimages"
                  data-text="Gallery Images"
                  draggable={
                    galleryimages && galleryimages.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    galleryimages && galleryimages.length > 0
                      ? disableField
                      : {}
                  }
                >
                  <i className="fa fa-upload"></i>
                  <p className="toolboxname">Gallery Images</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="video"
                  data-upload="10"
                  header-text="File"
                  data-default="true"
                  data-public="true"
                  data-name="galleryvideos"
                  data-text="Gallery Videos"
                  draggable={
                    galleryvideos && galleryvideos.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    galleryvideos && galleryvideos.length > 0
                      ? disableField
                      : {}
                  }
                >
                  <i className="fa fa-upload"></i>
                  <p className="toolboxname">Gallery Videos</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="document"
                  data-upload="5"
                  header-text="File"
                  data-default="true"
                  data-public="true"
                  data-name="documents"
                  data-text="Other Documents"
                  draggable={documents && documents.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={documents && documents.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-upload"></i>
                  <p className="toolboxname">Other Documents</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="videourl"
                  data-text="Video Link"
                  draggable={videourl && videourl.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={videourl && videourl.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-video-camera"></i>
                  <p className="toolboxname">Video Link</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="sponsor_spoc"
                  data-text="Contact Person"
                  draggable={
                    sponsor_spoc && sponsor_spoc.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    sponsor_spoc && sponsor_spoc.length > 0 ? disableField : {}
                  }
                >
                  <i className="fa fa-user"></i>
                  <p className="toolboxname">Contact Person</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="sponsoremail"
                  data-text="Email"
                  draggable={
                    sponsoremail && sponsoremail.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    sponsoremail && sponsoremail.length > 0 ? disableField : {}
                  }
                >
                  <i className="fa fa fa-envelope-o"></i>
                  <p className="toolboxname">Email</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="false"
                  data-name="phonenumber"
                  data-text="Phone Number"
                  draggable={
                    phonenumber && phonenumber.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    phonenumber && phonenumber.length > 0 ? disableField : {}
                  }
                >
                  <i className="fa fa-phone"></i>
                  <p className="toolboxname">Phone Number</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textarea"
                  header-text="Textarea"
                  data-default="true"
                  data-public="true"
                  data-name="address"
                  data-text="Address"
                  draggable={address && address.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={address && address.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-map-marker"></i>
                  <p className="toolboxname">Address</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="dropdown"
                  header-text="Country"
                  data-default="true"
                  data-public="true"
                  data-name="country"
                  data-text="country"
                  draggable={country && country.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={country && country.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-globe"></i>
                  <p className="toolboxname">Country</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="weblink"
                  data-text="Website"
                  draggable={website && website.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={website && website.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-globe"></i>
                  <p className="toolboxname">Website</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="facebook"
                  data-text="Facebook"
                  draggable={facebook && facebook.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={facebook && facebook.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-facebook"></i>
                  <p className="toolboxname">Facebook</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="twitter"
                  data-text="Twitter"
                  draggable={twitter && twitter.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={twitter && twitter.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-twitter"></i>
                  <p className="toolboxname">Twitter</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="linkedin"
                  data-text="Linkedin"
                  draggable={linkedin && linkedin.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={linkedin && linkedin.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-linkedin"></i>
                  <p className="toolboxname">Linkedin</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="instagram"
                  data-text="Instagram"
                  draggable={instagram && instagram.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={instagram && instagram.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-instagram"></i>
                  <p className="toolboxname">Instagram</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="whatsapp"
                  data-text="Whatsapp"
                  draggable={whatsapp && whatsapp.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={whatsapp && whatsapp.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-whatsapp"></i>
                  <p className="toolboxname">Whatsapp</p>
                </li>
              </ul>
            ) : source === "checkout" || source == "proposal" ? (
              <ul>
                <li
                  className="d-flex content-centertab"
                  data-key="textarea"
                  header-text="Textarea"
                  data-default="true"
                  data-public="true"
                  data-name="biography"
                  data-text="Bio"
                  draggable={biagrophy && biagrophy.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={biagrophy && biagrophy.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-id-card"></i>
                  <span className="toolboxname">Bio</span>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="company"
                  data-text="Company"
                  draggable={company && company.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={company && company.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-industry"></i>
                  <p className="toolboxname">Company</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="designation"
                  data-text="Designation"
                  draggable={
                    designation && designation.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    designation && designation.length > 0 ? disableField : {}
                  }
                >
                  <i className="fa fa-font"></i>
                  <p className="toolboxname">Designation</p>
                </li>
                {/* <li data-key="checkboxes" header-text="Checkbox" data-default="true" data-name="interest" data-text="Interest" draggable={interest && interest.length>0 ? false : true} onDragEnd={this.dragNewElement} style={interest && interest.length>0 ? disableField : {}}><i className="fa fa-check-square-o"></i>Interest</li> */}
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="false"
                  data-name="phonenumber"
                  data-text="Phone Numbaer"
                  draggable={
                    phonenumber && phonenumber.length > 0 ? false : true
                  }
                  onDragEnd={this.dragNewElement}
                  style={
                    phonenumber && phonenumber.length > 0 ? disableField : {}
                  }
                >
                  <i className="fa fa-phone"></i>
                  <p className="toolboxname">Phone Number</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="dropdown"
                  header-text="Country"
                  data-default="true"
                  data-public="true"
                  data-name="country"
                  data-text="country"
                  draggable={country && country.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={country && country.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-globe"></i>
                  <p className="toolboxname">Country</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="facebook"
                  data-text="Facebook"
                  draggable={facebook && facebook.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={facebook && facebook.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-facebook"></i>
                  <p className="toolboxname">Facebook</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="twitter"
                  data-text="Twitter"
                  draggable={twitter && twitter.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={twitter && twitter.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-twitter"></i>
                  <p className="toolboxname">Twitter</p>
                </li>
                <li
                  className="d-flex content-centertab"
                  data-key="textinput"
                  header-text="Input"
                  data-default="true"
                  data-public="true"
                  data-name="linkedin"
                  data-text="Linkedin"
                  draggable={linkedin && linkedin.length > 0 ? false : true}
                  onDragEnd={this.dragNewElement}
                  style={linkedin && linkedin.length > 0 ? disableField : {}}
                >
                  <i className="fa fa-linkedin"></i>
                  <p className="toolboxname">Linkedin</p>
                </li>
                {/* <li data-key="singlecheckbox" header-text="Checkbox" data-default="true" data-name="isnetworking" data-text="Networking/GDPR Consent (This will enable you to share your profile and connect with other users.)" draggable={gdpr && gdpr.length>0 ? false : true} onDragEnd={this.dragNewElement} style={gdpr && gdpr.length>0 ? disableField : {}}><i className="fa fa-check-square-o"></i>GDPR</li>
                    <li data-key="singlecheckbox" header-text="Checkbox" data-default="true" data-name="termsconditions" data-text="Terms & Conditions" draggable={terms && terms.length>0 ? false : true} onDragEnd={this.dragNewElement} style={terms && terms.length>0 ? disableField : {}}><i className="fa fa-check-square-o"></i>Terms & Conditions</li> */}
              </ul>
            ) : source === "sessionrating" ? (
              <>
                {/* <ul>
                    <li
                      className="d-flex content-centertab"
                      data-key="rating"
                      header-text="Rating"
                      data-default="true"
                      data-public="true"
                      data-name="general"
                      data-text="General Rating"
                      draggable={
                        sessiongr && sessiongr.length > 0 ? false : true
                      }
                      onDragEnd={this.dragNewElement}
                      style={
                        sessiongr && sessiongr.length > 0 ? disableField : {}
                      }
                    >
                      <i className="fa fa-star"></i>
                      <p className="toolboxname">General</p>
                    </li>
                    <li
                      className="d-flex content-centertab"
                      data-key="rating"
                      header-text="Rating"
                      data-default="true"
                      data-public="true"
                      data-name="speaking"
                      data-text="Speaking"
                      draggable={
                        sessionsr && sessionsr.length > 0 ? false : true
                      }
                      onDragEnd={this.dragNewElement}
                      style={
                        sessionsr && sessionsr.length > 0 ? disableField : {}
                      }
                    >
                      <i className="fa fa-star"></i>
                      <p className="toolboxname">Speaking</p>
                    </li>
                    <li
                      className="d-flex content-centertab"
                      data-key="rating"
                      header-text="Rating"
                      data-default="true"
                      data-public="true"
                      data-name="presentation"
                      data-text="Presentation Content"
                      draggable={
                        sessionpr && sessionpr.length > 0 ? false : true
                      }
                      onDragEnd={this.dragNewElement}
                      style={
                        sessionpr && sessionpr.length > 0 ? disableField : {}
                      }
                    >
                      <i className="fa fa-star"></i>
                      <p className="toolboxname">Presentation Content</p>
                    </li>
                    <li
                      className="d-flex content-centertab"
                      data-key="textinput"
                      header-text="Input"
                      data-default="true"
                      data-public="true"
                      data-name="comment"
                      data-text="Comment"
                      draggable={
                        sessioncomment && sessioncomment.length > 0
                          ? false
                          : true
                      }
                      onDragEnd={this.dragNewElement}
                      style={
                        sessioncomment && sessioncomment.length > 0
                          ? disableField
                          : {}
                      }
                    >
                      <i className="fa fa-industry"></i>
                      <p className="toolboxname">Comment</p>
                    </li>
                  </ul> */}
              </>
            ) : (
              ""
            )}

            {source === "checkout" ? (
              <p className="vertical-align-center subheading-formcomponent">
                {LocaleStrings.dynamic_form_text_additional_fields}{" "}
                <OverlayTrigger
                  key="contact-fields"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-contact-fields">
                      {LocaleStrings.dynamic_form_text_additional_fields_info}
                    </Tooltip>
                  }
                >
                  <i className="fa fa-info-circle pointer ml-10"></i>
                </OverlayTrigger>
              </p>
            ) : (
              <p className="subheading-formcomponent">
                {LocaleStrings.dynamic_form_text_additional_fields}
              </p>
            )}

            <ul>
              {source === "sessionrating" ? (
                <li
                  className="d-flex content-centertab"
                  data-key="rating"
                  header-text="Rating"
                  data-default="false"
                  data-public="true"
                  data-name="rating"
                  data-text="Rating"
                  draggable="true"
                  onDragEnd={this.dragNewElement}
                >
                  <i className="fa fa-star text-custom-theme"></i>
                  <p className="toolboxname">Rating</p>
                </li>
              ) : (
                ""
              )}
              <li
                className="d-flex content-centertab"
                data-key="textinput"
                header-text="Input"
                data-default="false"
                data-public="true"
                data-name="input"
                data-text="input"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-font"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/textinput.png"
                ></img>
                <p className="toolboxname">Text Input</p>
              </li>
              <li
                className="d-flex content-centertab"
                data-key="numberinput"
                header-text="Number"
                data-default="false"
                data-public="true"
                data-name="number"
                data-text="number"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-plus"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/numberinput.png"
                ></img>
                <p className="toolboxname">Number Input</p>
              </li>
              <li
                className="d-flex content-centertab"
                data-key="textarea"
                header-text="Textarea"
                data-default="false"
                data-public="true"
                data-name="textarea"
                data-text="textarea"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-text-height"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/multiline.png"
                ></img>
                <p className="toolboxname">Multi-line Input</p>
              </li>
              <li
                className="d-flex content-centertab"
                data-key="checkboxes"
                header-text="Checkbox"
                data-default="false"
                data-public="true"
                data-name="checkbox"
                data-text="checkbox"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-check-square-o"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/checkbox.png"
                ></img>
                <p className="toolboxname">Checkboxes</p>
              </li>
              <li
                className="d-flex content-centertab"
                data-key="radiobuttons"
                header-text="Radio Button"
                data-default="false"
                data-public="true"
                data-name="radio"
                data-text="radiobuttons"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-dot-circle-o"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/multiplechoice.png"
                ></img>
                <p className="toolboxname">Multiple Choice</p>
              </li>
              <li
                className="d-flex content-centertab"
                data-key="dropdown"
                header-text="Dropdown"
                data-default="false"
                data-public="true"
                data-name="dropdown"
                data-text="dropdown"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-font"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/dropdown.png"
                ></img>
                <p className="toolboxname">Dropdown</p>
              </li>
              {/* <li data-key="image" header-text="Image" data-default="false" data-name="image" data-text="image" draggable="true" onDragEnd={this.dragNewElement}><i className="fa fa-photo"></i>Image</li> */}
              <li
                className="d-flex content-centertab"
                data-key="datepicker"
                header-text="Datepicker"
                data-default="false"
                data-public="true"
                data-name="date"
                data-text="date"
                draggable="true"
                onDragEnd={this.dragNewElement}
              >
                {/* <i className="fa fa-calendar"></i> */}
                <img
                  className="form-builder-image"
                  src="../../style/images/checkoutform/datepicker.png"
                ></img>
                <p className="toolboxname">Date</p>
              </li>
              {source !== "sessionrating" ? (
                <li
                  className="d-flex content-centertab"
                  data-key="hyperlink"
                  header-text="Hyperlink"
                  data-default="false"
                  data-public="true"
                  data-name="hyperlink"
                  data-text="hyper link"
                  draggable="true"
                  onDragEnd={this.dragNewElement}
                >
                  {/* <i className="fa fa-link"></i> */}
                  <img
                    className="form-builder-image"
                    src="../../style/images/checkoutform/hyperlink.png"
                  ></img>
                  <p className="toolboxname">Hyper link</p>
                </li>
              ) : (
                ""
              )}
              {source !== "sessionrating" ? (
                <li
                  className="d-flex content-centertab"
                  data-key="label"
                  header-text="Label"
                  data-default="false"
                  data-public="true"
                  data-name="label"
                  data-text="label"
                  draggable="true"
                  onDragEnd={this.dragNewElement}
                >
                  {/* <i className="fa fa-tag"></i> */}
                  <img
                    className="form-builder-image"
                    src="../../style/images/checkoutform/label.png"
                  ></img>
                  <p className="toolboxname">Label</p>
                </li>
              ) : (
                ""
              )}
              {source !== "sessionrating" ? (
                <li
                  className="d-flex content-centertab"
                  data-key="paragraph"
                  header-text="Paragraph"
                  data-default="false"
                  data-public="true"
                  data-name="paragraph"
                  data-text="Enter your paragraph here"
                  draggable="true"
                  onDragEnd={this.dragNewElement}
                >
                  {/* <i className="fa fa-paragraph"></i> */}
                  <img
                    className="form-builder-image"
                    src="../../style/images/checkoutform/paragraph.png"
                  ></img>
                  <p className="toolboxname">Paragraph</p>
                </li>
              ) : (
                ""
              )}
              {source === "proposal" ? (
                <li
                  className="d-flex content-centertab"
                  data-key="group"
                  data-type="abstract"
                  data-entries="2"
                  header-text="Group Data"
                  data-default="false"
                  data-public="true"
                  data-name="abstract"
                  data-text=""
                  draggable="true"
                  onDragEnd={this.dragNewElement}
                >
                  <i className="text-custom-theme fa fa-shield"></i>
                  <p className="toolboxname">Abstract Info</p>
                </li>
              ) : (
                ""
              )}

              {source === "proposal" ||
              source === "exhibitor" ||
              source === "sponsor" ? (
                <li
                  className="d-flex content-centertab"
                  data-key="file"
                  data-type="image"
                  data-upload="1"
                  header-text="File Uploader"
                  data-default="false"
                  data-public="true"
                  data-name="uploader"
                  data-text="File Upload"
                  draggable="true"
                  onDragEnd={this.dragNewElement}
                >
                  <i className="text-custom-theme fa fa-upload"></i>
                  <p className="toolboxname">File Upload</p>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    oldKeys: state.formList,
    session: state.session,
    formName: state.formName,
    CountryList: state.CountryList,
  };
}

export default connect(mapStateToProps, {
  updateFormList,
  updateFomeName,
  formEdited,
})(FormBuilder);
